import React, { useState, useEffect } from "react";
import { Form, Input, InputNumber, Button, message, Tag } from "antd";
import axiosInstance from "@/axios/axiosInstance";
import MyCustomUploadAdapterPlugin from "@/assets/MyEditorComponent";
import { useNavigate, useLocation } from "react-router-dom";
import UploadAgreement from "@/components/UploadAgreement";
import "./index.scss";

const PublishVideo = () => {
  const navigate = useNavigate(); // 获取 navigate 函数
  const [form] = Form.useForm();
  const [selectedTag, setSelectedTag] = useState("1");
  const [datadTag, setSelectedDataTag] = useState("1");
  const [dataDetail, setDatali] = useState({});
  const [content, setContent] = useState("");
  const [agreeToUpload, setAgreeToUpload] = useState(true); // 默认勾选

  const handleTagClick = (tag) => {
    if (selectedTag !== tag.key) {
      setSelectedTag(tag.key);
    }
  };
  const handleDataTagClick = (tag) => {
    if (datadTag !== tag.key) {
      setSelectedDataTag(tag.key);
    }
  };

  let location = useLocation();
  let { state } = location;
  let itemId = state?.id;
  const fetchDetails = async (id) => {
    try {
      const response = await axiosInstance.get(
        `serviceManager/account/detail?serviceManagerId=${id}`
      );
      setDatali(response.data.data);
      // setdataSource(response.data.data);
    } catch (error) {
      console.error("Error fetching user info:", error);
    }
  };

  useEffect(() => {
    if (itemId) {
      fetchDetails(itemId); // 如果itemId存在，
    }
  }, [itemId]); // 空依赖数组确保只运行一次// 空数组作为依赖项表示这个 effect 只在组件挂载时运行一次

  useEffect(() => {
    // 当dataDetail更新时，更新表单的值
    if (Object.keys(dataDetail).length > 0) {
      form.setFieldsValue({
        ...dataDetail,
      });

      setSelectedTag(dataDetail.serviceType + "");
      setSelectedDataTag(dataDetail.paymentType + "");
    }
  }, [dataDetail, form]); // 依赖dataDetail和form，以便在它们变化时重新运行

  const onFinish = (values) => {
    console.log(values);
    const formData = new FormData();
    formData.append("title", values.title);
    formData.append("introduction", content);
    formData.append("servicePrincipal", values.servicePrincipal);
    formData.append("serviceType", selectedTag);
    formData.append("paymentType", datadTag);
    formData.append("paymentPrice", values.price);
    let url = "serviceManager/account/save";

    if (itemId) {
      formData.append("datasetIdArray", itemId);
      url = "serviceManager/account/update";
    }
    try {
      axiosInstance
        .post(url, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.data.code == "10000") {
            message.success("保存成功");
            form.resetFields();
            navigate("/personal?selectedKey=6&openKeys=sub2&openKeys=sub1");
          } else {
            message.error("保存失败");
          }
        })
        .catch((error) => {
          // 处理错误情况
          console.error("Error fetching user info:", error);
        });
    } catch (error) {
      // 处理错误情况
      console.error("Error fetching user info:", error);
    }
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 6 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 14 },
    },
  };

  const fileOptions = [
    { key: "1", value: "AI规划咨询" },
    { key: "2", value: "AI系统方案设计 " },
    { key: "3", value: "AI数据处理" },
    { key: "4", value: "AI模型训练" },
    { key: "5", value: "AI产品开发" },
    { key: "6", value: "AI模型部署" },
    { key: "11", value: "AI聊天" },
    { key: "22", value: "AI绘画 " },
    { key: "33", value: "AI视频" },
    { key: "44", value: "AI语言处理" },
    { key: "55", value: "AI办公效率提升" },
    { key: "66", value: "AI审计风控" },
  ].map((tag) => (
    <Tag
      color={selectedTag === tag.key ? "blue" : "default"}
      key={tag.key}
      onClick={() => handleTagClick(tag)}
    >
      {tag.value}
    </Tag>
  ));
  const dataOptions = [
    { key: "1", value: "按时付费" },
    { key: "2", value: "按需定制  " },
    { key: "3", value: "标准定价" },
  ].map((tag) => (
    <Tag
      color={datadTag === tag.key ? "blue" : "default"}
      key={tag.key}
      onClick={() => handleDataTagClick(tag)}
    >
      {tag.value}
    </Tag>
  ));

  const onReset = () => {
    form.resetFields();
    navigate("/personal?selectedKey=6&openKeys=sub2&openKeys=sub1");
  };
  const initialValues = {
    price: 100,
    fileSize: 100,
  };
  return (
    <Form
      form={form}
      {...formItemLayout}
      name="dataset_form"
      initialValues={initialValues} // 设置初始值
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
    >
      <Form.Item
        label="标题"
        name="title"
        rules={[{ required: true, message: "请输入标题!" }]}
      >
        <Input showCount maxLength={20} />
      </Form.Item>
      <Form.Item
        label="简介"
        name="introduction"
        rules={[{ required: true, message: "请输入简介!" }]}
      >
        <MyCustomUploadAdapterPlugin value={content} onChange={setContent} />
      </Form.Item>
      <Form.Item
        label="服务主体"
        name="servicePrincipal"
        rules={[
          { required: true, message: "请输入提供此服务的工商经营主体名称 !" },
        ]}
      >
        <Input showCount maxLength={20} />
      </Form.Item>
      <Form.Item label="类型" name="serviceType">
        <div>{fileOptions}</div>
      </Form.Item>

      {
        <Form.Item label="价格 " name="paymentType">
          <div>{dataOptions}</div>
        </Form.Item>
      }
      <Form.Item
        label="价格（元）"
        name="price"
        rules={[{ required: true, message: "必填" }]}
      >
        <InputNumber />
      </Form.Item>
      <Form.Item wrapperCol={{ offset: 6, span: 16 }}>
        <UploadAgreement checked={agreeToUpload} onChange={setAgreeToUpload} />
        <Button
          type="primary"
          htmlType="submit"
          style={{ marginRight: "40px", marginBottom: "30px" }}
        >
          提交
        </Button>
        <Button htmlType="button" onClick={onReset}>
          取消
        </Button>
      </Form.Item>
    </Form>
  );
};
export default PublishVideo;
